
export const TYPES = {
    init: 0,
    loadSettings: 1,
    createCustomer: 2,
    createPaymentIntent: 3,
    cancelPaymentIntent: 4,
    createSetupIntent: 5,
    cancelSetupIntent: 6,
    savePaymentData: 7,
    removePaymentMethods: 8,
    setAsDefaultPaymentMethod: 9,
    setDoNotRenew: 10,
    chargePayment: 11,
    updatePaymentSettings: 12,
    startFreeTrial: 13,
    setPreferredMethod: 14,
};

export const PAYMENTS_ENDPOINT = "/VDP/payments/Payments.act";

export const RESPONSE_TYPES = {
    none: 0,
    success: 1,
    error: 2,
    processing: 3,
}

export const SUBSCRIPTION_ROOT_PAGES = {
    HOME: 1,
    AC: 2,
    VRI: 3,
    VDS: 4
};

export const PAYMENT_METHOD_PAGES = {
    SPLASH: 1,
    ADD_NEW: 2,
    HISTORY: 3,
};

export const AC_PAGES = {
    SPLASH: 1,
    PLAN_DETAILS: 2,
    CHECKOUT: 3,
    MANAGE: 4,
};

export const VRI_PAGES = {
    SPLASH: 1,
    PLAN_SELECT: 2,
    CHECKOUT: 3,
    MANAGE: 4,
    UPDATE_SUBSCRIPTION: 5,
    UPDATE_SUBSCRIPTION_CONFIRM: 6
};

export const VDS_PAGES = {
    SPLASH: 1,
    PLAN_SELECT: 2,
    CHECKOUT: 3,
    MANAGE: 4,
    UPDATE_SUBSCRIPTION: 5,
    UPDATE_SUBSCRIPTION_CONFIRM: 6
};

export const CREATE_ACCOUNT_PAGES = {
    CHOOSE_ROUTE: 1,
    SELECT_FOR_AC: 2,
    SELECT_FOR_VRI: 3,
    CHECKOUT_VRI: 4,
    SELECT_FOR_VDS: 5,
    CHECKOUT_VDS: 6,
};

export const ROLES = {
    ADMIN: 3,
    VAR: 2,
    RESELLER: 1,
    END_USER: 0,
};

export const AC_DEV_LEVEL = {
    BASIC: 0,
    SERVER: 1,
    APP_BUILDER: 2,
    SDK: 3,
    FREE: 4
}

export const VRI_LEVEL = {
    NONE: 5,
    TIER_1_YEARLY: 6,
    TIER_2_YEARLY: 7,
    TIER_3_YEARLY: 8,
    TIER_4_YEARLY: 9,
    TIER_5_YEARLY: 10,
    UNLIMITED_YEARLY: 11,
    TIER_1_MONTHLY: 12,
    TIER_2_MONTHLY: 13,
    TIER_3_MONTHLY: 14,
    TIER_4_MONTHLY: 15,
    TIER_5_MONTHLY: 16,
    UNLIMITED_MONTHLY: 17,
};

export const isMonthly = (level) => [VRI_LEVEL.TIER_1_MONTHLY, VRI_LEVEL.TIER_2_MONTHLY,
    VRI_LEVEL.TIER_3_MONTHLY, VRI_LEVEL.TIER_4_MONTHLY, VRI_LEVEL.TIER_5_MONTHLY,
    VRI_LEVEL.UNLIMITED_MONTHLY, VDS_LEVEL.TIER_1_MONTHLY, VDS_LEVEL.UNLIMITED_MONTHLY].includes(level);

export const VDS_LEVEL = {
    NONE: 30,
    TIER_1_YEARLY: 18,
    UNLIMITED_YEARLY: 23,
    TIER_1_MONTHLY: 24,
    UNLIMITED_MONTHLY: 29,
};

export const SUB_TYPE = {
    VRI: 1,
    VDS: 2
};

export const PAYMENT_TYPE = {
    AC: 1,
    VRI: 2,
    VDS: 3
};

export const UPDATE_SUB_ACTION = {
    SPLASH: 1,
    DOWNGRADE: 2,
    UPGRADE: 3,
    RECURRENCE: 4,
};